import React, { useState, useEffect, useRef } from 'react';
import {
  ButtonGroup,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem
} from '@material-ui/core';
import { Button } from 'components/Base';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';

const ButtonDropdown = ({
  disabled = false,
  options,
  setOption,
  defaultOption = 0
}: {
  disabled?: boolean;
  options: any[];
  setOption: Function;
  defaultOption?: number;
}) => {
  const [open, setOpen] = useState(false);
  const [selectedOptionIndex, setselectedOptionIndex] = useState(defaultOption);
  const anchorRef = useRef(null) as any;

  useEffect(() => {
    setOption(selectedOptionIndex);
  }, [selectedOptionIndex]);

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleMenuItemClick = (event: any, index: number) => {
    setselectedOptionIndex(index);
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        ref={anchorRef}
        disabled={disabled}
        variant="contained"
        color="secondary"
        aria-label="split button"
      >
        <Button type="submit">{options[selectedOptionIndex]}</Button>
        <Button
          color="secondary"
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={(e: any) => {
            e.preventDefault();
            setOpen((prevOpen: any) => !prevOpen);
          }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 100 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedOptionIndex}
                      onClick={event => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default ButtonDropdown;
